
import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import AnnouncementBanner from './components/AnnouncementBanner'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import CookieConsent from './components/CookieConsent'
import ScrollToTop from './components/ScrollToTop'
import ViewingBanner from './components/ViewingBanner'
import Home from './pages/Home'
import Resources from './pages/Resources'
import About from './pages/About'
import Contact from './pages/Contact'
import Privacy from './pages/Privacy'
import Disclaimer from './pages/Disclaimer'
import Signup from './pages/Signup'
import SouthAsia from './pages/SouthAsia'
import UKEurope from './pages/UKEurope'
import Countries from './pages/Countries'
import SouthAsiaCountry from './pages/SouthAsiaCountry'
import SoutheastAsiaCountry from './pages/SoutheastAsiaCountry'
import GCCCountry from './pages/GCCCountry'
import AfricaCountry from './pages/AfricaCountry'
import UnitedStatesCountry from './pages/UnitedStatesCountry'
import FAQ from './pages/FAQ'
import Recruiters from './pages/Recruiters'
import RecruitersApply from './pages/RecruitersApply'
import Affiliates from './pages/Affiliates'
import AffiliatesApply from './pages/AffiliatesApply'
import AuthGateway from './pages/AuthGateway'
import RoleSelect from './pages/RoleSelect'
import OnboardingStepper from './pages/OnboardingStepper'
import NurseDashboard from './pages/NurseDashboard_New'
import RecruiterDashboard from './pages/RecruiterDashboard'
import AffiliateDashboard from './pages/AffiliateDashboard'
import SuperadminDashboard from './pages/SuperadminDashboard'
import SuperadminUsersDirectory from './pages/SuperadminUsersDirectory'
import SuperadminAdminsDirectory from './pages/SuperadminAdminsDirectory'
import SuperadminInvites from './pages/SuperadminInvites'
import SuperadminEmailAnalytics from './pages/SuperadminEmailAnalytics'
import AdminDashboard from './pages/AdminDashboard'

import DashboardResolver from './pages/DashboardResolver'
import ProtectedRoute from './components/ProtectedRoute'
import MessagesPage from './pages/MessagesPage'
import AdminDocumentQueue from './pages/AdminDocumentQueue'
import NurseVisibilitySettings from './pages/NurseVisibilitySettings'
import AdminMOUApproval from './pages/AdminMOUApproval'
import AdminContactInbox from './pages/AdminContactInbox'

function App() {
  const [showCookieConsent, setShowCookieConsent] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent')
    if (!consent) {
      setShowCookieConsent(true)
    }
  }, [])

  const handleCookieConsent = () => {
    localStorage.setItem('cookieConsent', 'accepted')
    setShowCookieConsent(false)
  }

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white font-inter">
        <ViewingBanner />
        <AnnouncementBanner />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/about" element={<About />} />
            <Route path="/countries" element={<Countries />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/south-asia" element={<SouthAsia />} />
            <Route path="/uk-europe" element={<UKEurope />} />
            <Route path="/countries/south-asia" element={<SouthAsiaCountry />} />
            <Route path="/countries/southeast-asia" element={<SoutheastAsiaCountry />} />
            <Route path="/countries/gcc" element={<GCCCountry />} />
            <Route path="/countries/africa" element={<AfricaCountry />} />
            <Route path="/countries/united-states" element={<UnitedStatesCountry />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/faqs" element={<FAQ />} />
            <Route path="/destinations" element={<Countries />} />
            <Route path="/recruiters" element={<Recruiters />} />
            <Route path="/recruiters/apply" element={<RecruitersApply />} />
            <Route path="/affiliates" element={<Affiliates />} />
            <Route path="/affiliates/apply" element={<AffiliatesApply />} />
            {/* Auth Routes */}
            <Route path="/auth" element={<AuthGateway />} />
            <Route path="/register" element={<AuthGateway />} />
            <Route path="/signin" element={<AuthGateway />} />
            <Route path="/login" element={<AuthGateway />} />
            <Route path="/register-free" element={<AuthGateway />} />
            
            {/* Onboarding Routes */}
            <Route path="/onboarding/role" element={<RoleSelect />} />
            <Route path="/onboarding/profile" element={<OnboardingStepper />} />
            
            {/* Dashboard Routes */}
            <Route path="/dashboard" element={<DashboardResolver />} />
            <Route path="/dashboard/nurse" element={<NurseDashboard />} />
            <Route path="/dashboard/nurse/messages" element={<MessagesPage />} />
            <Route path="/dashboard/nurse/visibility" element={<NurseVisibilitySettings />} />
            <Route path="/dashboard/recruiter" element={<RecruiterDashboard />} />
            <Route path="/dashboard/recruiter/messages" element={<MessagesPage />} />
            <Route path="/dashboard/affiliate" element={<AffiliateDashboard />} />
            <Route path="/dashboard/affiliate/messages" element={<MessagesPage />} />
            <Route path="/dashboard/admin" element={<AdminDashboard />} />
            <Route path="/messages" element={<MessagesPage />} />
            <Route path="/dashboard/admin/messages" element={<MessagesPage />} />
            <Route path="/admin/documents" element={<AdminDocumentQueue />} />
            <Route path="/admin/mou" element={<AdminMOUApproval />} />
            <Route path="/admin/contacts" element={<AdminContactInbox />} />

            <Route path="/dashboard/superadmin" element={<SuperadminDashboard />} />
            <Route path="/dashboard/superadmin/messages" element={<MessagesPage />} />
            <Route path="/dashboard/superadmin/users" element={<SuperadminUsersDirectory />} />
            <Route path="/dashboard/superadmin/admins" element={<SuperadminAdminsDirectory />} />
            <Route path="/dashboard/superadmin/invites" element={<SuperadminInvites />} />
            <Route path="/dashboard/superadmin/email-analytics" element={<SuperadminEmailAnalytics />} />
          </Routes>
        </main>
        <Footer />
        {showCookieConsent && (
          <CookieConsent onAccept={handleCookieConsent} />
        )}
        <Toaster position="top-right" />
      </div>
    </Router>
  )
}

export default App
